// extracted by mini-css-extract-plugin
export default {"box":"SKdSBX3pdLsT_VgNzdgt","titleBlock":"tbR4OxXca0glZslVUmw0"};